import { useState } from 'react';

import { useOnceReveal } from '@common/hooks';
import { PdpProductSizeType, PopupViewType, usePopupView, useTimeoutTooltip } from '@domains/pdp-common';

import { SizeRecommendationModel } from '../utils/types';
import { useLegacySizeRecommendationService } from './useLegacySizeRecommendationService';

export const useLegacySimilarSizeService = () => {
  const { showPopup } = usePopupView();
  const [optionCount, setOptionCount] = useState<number>(2);
  const [infoOpen, setInfoOpen] = useState<boolean>(false);

  const { targetRef, isRevealed } = useOnceReveal({ threshold: 1.0 });
  const { isTooltipShown } = useTimeoutTooltip({
    key: 'isSizeRecommendTooltipShown',
    time: 3000,
    dep: [isRevealed],
    isUnrevealed: () => !isRevealed,
  });

  const language = 'ko';

  const { sizeRecommendation } = useLegacySizeRecommendationService();

  const { recommendationType, recommendOptionValueList, userAccount } = sizeRecommendation;

  const handleInfoClick = () => {
    showPopup(PopupViewType.SIZE_INFO, () => {
      setInfoOpen(true);
    });
  };

  const title =
    language === 'ko' || recommendationType === PdpProductSizeType.RECOMMENDATION
      ? `${userAccount.name}님의 체형은`
      : '당신의 체형은';

  const handleMoreClick = () => {
    setOptionCount(recommendOptionValueList.length);
  };

  const closeTooltip = () => {
    setInfoOpen(false);
  };

  return {
    tooltipRef: targetRef,
    handleInfoClick,
    isTooltipShown,
    title,
    isPurchaseType: recommendationType === PdpProductSizeType.PURCHASE,
    recommendOption: getRecommendOption(recommendOptionValueList),
    language,
    userAccount,
    recommendOptionValueList: recommendOptionValueList.slice(0, optionCount),
    moreVisible: optionCount < 3 && recommendOptionValueList.length > 2,
    handleMoreClick,
    infoOpen,
    closeTooltip,
    isOptionType: recommendationType === PdpProductSizeType.OPTION,
  };
};

function getRecommendOption(list: SizeRecommendationModel['recommendOptionValueList']) {
  if (list.length === 0) {
    return '';
  }

  return list.reduce((name, option, index) => {
    if (option.ranking === 1 && index > 0) {
      name += `, ${option.name}`;
    }
    return name;
  }, list[0].name);
}
